import { createSelector } from 'reselect'

export const getLayoutIds = (state, props) => {
  return state['view-home'].view.layouts
}

export default createSelector(
  [
    getLayoutIds
  ],
  (
    layoutIds
  ) => ({
    layoutIds
  })
)
